// extracted by mini-css-extract-plugin
export default {"wrapper":"BalanceCard_wrapper__aF27R","balance":"BalanceCard_balance__0Dehc"};